import { Component, EventEmitter, Output, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../common.service';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'pdfInfoDialog',
  templateUrl: 'pdfInfo.html'
})
export class PdfInfoDialog implements AfterViewInit {
  registration: FormGroup;
  public message: string;
  public distName: string = '';
  public distCompany: string = '';
  public user: string;
  public company: string;
  @Output() dialogDist: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    public dialogRef: MatDialogRef<PdfInfoDialog>,
    public commonService: CommonService,
    private formBuilder: FormBuilder,
    private dialog: MatDialog
  ) {
    this.registration = this.formBuilder.group({
      distName: new FormControl(''),
      distCompany: new FormControl(''),
      endUserName: new FormControl(''),
      endUserCompany: new FormControl('')
    });
  }

  closeDistModal = () => {
    this.commonService.notifyOther({
      option: 'dialog',
      value: {
        distName: this.registration.get('distName').value,
        distCompany: this.registration.get('distCompany').value,
        endUserName: this.registration.get('endUserName').value,
        endUserCompany: this.registration.get('endUserCompany').value
      }
    });
    this.dialog.closeAll();
  };

  ngAfterViewInit() {
    this.registration.get('endUserName').patchValue(this.user, { emitEvent: false });
    this.registration.get('endUserCompany').patchValue(this.company, { emitEvent: false });
  }
}
